import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Twitter, Instagram } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Home', path: '/' },
    { label: 'Startups', path: '/startups' },
    { label: 'Stories', path: '/stories' },
    { label: 'Contact', path: '/contact' },
  ];

  const socialLinks = [
    { icon: Linkedin, label: 'LinkedIn', href: 'https://www.linkedin.com/company/litsparkin' },
    { icon: Twitter, label: 'X (Twitter)', href: 'https://twitter.com/litsparkin' },
    { icon: Instagram, label: 'Instagram', href: 'https://www.instagram.com/litsparkin' },
  ];

  return (
    <footer className="bg-foreground text-background py-12 mt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold font-heading mb-4">
              <span className="bg-gradient-primary bg-clip-text text-transparent">Starticals</span>
            </h3>
            <p className="text-background/80 leading-relaxed">
              Amplifying startup journeys and celebrating entrepreneurial achievements worldwide.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-background/80 hover:text-background transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Connect With Us</h4>
            <div className="flex gap-4">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    className="p-3 bg-background/10 hover:bg-background/20 rounded-full transition-all hover:scale-110"
                    aria-label={social.label}
                  >
                    <Icon className="h-5 w-5" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-background/20 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background/70 text-sm">
            © {currentYear} Starticals. All rights reserved.
          </p>
          <p className="text-background/70 text-sm">
            Built by <span className="font-semibold text-background">LitSpark Solutions</span>
          </p>
        </div>
      </div>
    </footer>
  );
};
